export default __webpack_public_path__ + "static/media/p61.4495daa2.jpg";